import React from 'react';
import Navbar from './components/Navbar';
import Sidebar from './components/Sidebar';
import About from './components/About';
import TechStack from './components/TechStack';
import Experience from './components/Experience';
import Projects from './components/Projects';
import DSAStatus from './components/DsaStatus';
import Education from './components/Education';
import Footer from './components/Footer';
import OpenSource from './components/OpenSource';
import Writings from './components/Writings';
import { MarqueeTicker, StatBar, TerminalBlock, QuoteBand, OrbitalBadge } from './components/Dividers';

export default function App() {
  return (
    <div
      className="min-h-screen relative"
      style={{
        background: '#F7F5EF',
        backgroundImage: `
          linear-gradient(rgba(0,0,0,0.055) 1px, transparent 1px),
          linear-gradient(90deg, rgba(0,0,0,0.055) 1px, transparent 1px)
        `,
        backgroundSize: '40px 40px',
      }}
    >
      {/* Sidebar — desktop only */}
      <div className="hidden lg:block">
        <Sidebar />
      </div>

      {/* Top Navbar — mobile only */}
      <div className="lg:hidden">
        <Navbar />
      </div>

      {/* Main scrollable content pushed right of sidebar on desktop */}
      <main className="lg:ml-56 overflow-x-hidden" style={{ background: '#F7F5EF' }}>
        <About />
        <MarqueeTicker />
        <TechStack />
        <Experience />
        <StatBar />
        <OpenSource />
        <TerminalBlock />
        <Projects />
        <QuoteBand />
        <DSAStatus />
        <OrbitalBadge />
        <Writings />
        <Education />
        <Footer />
      </main>

    </div>
  );
}